'use client';

import { useEffect } from 'react';
import { useAuthStore, useLanguageStore, useCountryStore } from '@/lib/store';

// Custom hook to handle hydration for Zustand stores
export function useHydration() {
  useEffect(() => {
    useAuthStore.persist.rehydrate();
    useLanguageStore.persist.rehydrate();
    useCountryStore.persist.rehydrate();
  }, []);
}
